import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const BlankCard = styled.div`
  ${({ theme }) => css`
    height: auto;
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 4px #15223214;
    border-radius: 6px;
    opacity: 1;
    padding: 12px;
    padding-top: 9px;
    margin-bottom: 40px;
  `}
`;

export const CardHeader = styled.div`
  ${({ theme }) => css`
    padding-bottom: 8px;
    padding-left: 5px;
    border-bottom: 1px solid ${rgba('#707070', 0.21)};
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;

    ${theme.breakpoints.down('xs')} {
      flex-wrap: wrap;

      div {
        display: flex;
        width: 100%;

        flex-wrap: wrap;
        justify-content: center;

        span {
          text-align: center;
          width: 100%;
        }
      }
      span {
        width: 100%;
      }
    }
  `}
`;

export const StatusContainer = styled.div`
  display: flex;
`;

export const Status = styled.span`
  ${({ theme }) => css`
    color: #fff;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    padding: 0 10px;
    border-radius: 15px;
    font-family: 'Poppins';
    font-size: 10px;
    font-weight: bold;
    margin-left: 10px;

    ${theme.breakpoints.down('xs')} {
      width: 100%;
      justify-content: center;
      display: flex;
      height: 20px;
    }

    &.pendente {
      background-color: #97992f;
    }

    &.emitido {
      background-color: #4485cf;
    }

    &.expirado {
      background-color: #b50076;
    }

    &.finalizado {
      background-color: #01b956;
    }

    &.cancelado {
      background-color: #db422e;
    }
  `}
`;

export const BottomInfos = styled.div`
  ${({ theme }) => css`
    display: flex;
    border-top: 1px solid ${rgba('#707070', 0.21)};
    margin-top: 10px;
    padding-top: 10px;

    ${theme.breakpoints.down('xs')} {
      flex-direction: column;
    }
  `}
`;

export const ExpirationDate = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
  color: red;
  padding-top: 15px;
`;

export const ValorTotal = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    font-size: 15px;
    font-weight: 500;
    ${theme.breakpoints.down('xs')} {
      margin-top: 20px;
      justify-content: center;
    }
  `}
`;

export const Travellers = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 70%;
  `}
`;

export const TravellerName = styled.span`
  ${({ theme }) => css`
    font-weight: 300;
    padding-top: 3px;
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    text-align: left;
    font: normal normal bold 15px Poppins;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;

    .subtitle {
      font-size: 11px;
      font-weight: 400;
      margin-left: 10px;
    }

    .subtitle-locator {
      font-size: 12px;
      font-weight: 500;
    }
  `}
`;

export const Subtitle = styled.div`
  ${({ theme }) => css`
    text-align: left;
    font: normal normal bold 10px Poppins;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  `}
`;

export const PackageSummaryCardDetails = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding-top: 10px;

    div {
      display: flex;
      flex-direction: column;
    }

    img {
      width: 180px;
      float: left;
      border-radius: 5px;
      margin-right: 15px;
    }
  `}
`;

export const ImagePlaceholder = styled.div`
  ${({ theme }) => css`
    width: 180px;
    height: 135px;
    background-color: #e0e0e0;
    border-radius: 5px;
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    span {
      color: #666;
      font-size: 11px;
      text-align: center;
      line-height: 1.4;
    }
  `}
`;

export const PackageDetails = styled.div`
  ${({ theme }) => css`
    display: flex;
    ${theme.breakpoints.down('xs')} {
      flex-wrap: wrap;
    }

    img {
      width: 220px;
      height: 180px;
      object-fit: cover;
      border-top-left-radius: 6px;

      ${theme.breakpoints.down('xs')} {
        width: 100%;
        border-top-right-radius: 6px;
      }
    }

    .package-info {
      margin-left: 15px;
      margin-top: 15px;
      font-size: 12px;

      .flights, .transfer, .locators {
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        gap: 3px;

        span {
          font-size: 11px;
        }
      }

      .locators {
        margin-top: 10px;
        color: #666;
      }
    }

    .content {
      margin-left: 15px;
      margin-top: 15px;
      border-bottom: 1px solid #e6e6e6;

      ${theme.breakpoints.down('xs')} {
        margin-left: 0px;
        padding-left: 10px;
        padding-right: 10px;
      }

      .package-description {
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 8px;
      }

      .hotel-details {
        display: flex;
        width: 100%;

        .hotel-name {
          font-size: 16px;
          font-weight: 600;
          padding-right: 50px;
        }
      }

      .dates-info {
        font-size: 12px;
        color: #666;
        margin-top: 5px;
        margin-bottom: 10px;
      }

      .cancel-policy {
        font-size: 11px;
        color: #ff5757;
        margin-top: 5px;
        margin-bottom: 10px;
      }
    }

    .stars {
      color: #ffb900;
      display: flex;
      flex-direction: row;
    }
  `}
`;

export const LoadingMessage = styled.div`
  ${({ theme }) => css`
    font-size: 12px;
    color: #999;
    font-style: italic;
    padding: 8px 5px;
  `}
`;
